module.exports = __webpack_public_path__ + "img/selected-gentry-of-hermitage.9bdf6d83.webp";